module.exports = __webpack_public_path__ + "img/141.aa21d5d7.jpg";